import { getServices } from '~/constants/services'
import { MARKET_TYPE } from '~/src/constants/markets'
import type { TMarketSlug } from '~/src/types/markets'

export const useMarketInsights = () => {
  const { getVimeoData, handlerPlay, vimeoSource, videoRatio, vimeoVideo } =
    useGetVimeoData()
  const { $graphqlClient, $rudderstack } = useNuxtApp()
  const { setInitialFields, open } = useModalStore()
  const { getReportAndModelData } = useReports()

  const playVideo = async (vimeoData: any, slug: TMarketSlug) => {
    const initialValues = getServices([slug, 'source'])
    const vimeoId = vimeoData?.vimeoId || vimeoData?.previewVimeoId
    const isPreviewVideo = !vimeoData?.vimeoId && !!vimeoData?.previewVimeoId
    setInitialFields(initialValues)

    if (!vimeoId) {
      $rudderstack.trackContentGatedInteraction()
      open('contact')
      return
    }

    await getVimeoData(vimeoId)
    handlerPlay()

    return isPreviewVideo
  }

  const getCriticalInsights = async (slug: TMarketSlug) => {
    const reports = await getReportAndModelData(
      slug,
      [MARKET_TYPE.CRITICAL_INSIGHTS],
      true,
      1,
    )
    return reports.map((report) => ({
      ...report,
      publishedDate: reformat(report.date, 'dd MMM yyyy'),
    }))
  }

  const getMarketInsightsData = async (
    market: TMarketSlug,
    categories: TMarketSlug[] = null,
  ) => {
    const [criticalInsights, marketInsights] = await Promise.all([
      getCriticalInsights(market),
      $graphqlClient.getMarketInsightsArticles({ market, categories }),
    ])
    const articles = marketInsights.articles
      .toSpliced(2, 0, ...criticalInsights)
      .slice(0, 5)
    const videos = marketInsights.videos
    const events = 'events' in marketInsights ? marketInsights.events : []
    return { articles, videos, events }
  }

  return {
    vimeoSource,
    videoRatio,
    vimeoVideo,
    playVideo,
    getMarketInsightsData,
  }
}
